import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, shareReplay } from 'rxjs';
import { runtimeConfig } from '../config/runtime-config';
import { LocationData } from '../model/LocationData';


@Injectable({
  providedIn: 'root'
})
export class UserLocationService {
  private readonly userCountry$: Observable<LocationData>;

  constructor(private readonly http: HttpClient) {
    this.userCountry$ = this.http.get<LocationData>(`${runtimeConfig.cloudCoreApiUrl}/api/v1/ipInfo`).pipe(
      shareReplay({ bufferSize: 1, refCount: false })
    );
  }

  public getUserCountry(): Observable<LocationData> {
    return this.userCountry$;
  }
}
